import React from 'react';
import { UserRowContainer, UserName, AddButton, AddedButton } from './style';
import { ProfileAvatar } from '../../ProfileAvatar/ProfileAvatar';
import { Text } from '../../../UI/Text';
import { config } from '../../../../Configurations';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { Spinner } from '../../Spiner/Spiner';
import { Icon } from '../../Icons/Icons';

class AddMemberRow extends React.Component {
    state = {
        isAdded: false,
        addedMemberId: null,
    };

    addUser = user_id => {
        this.props.onAdd({ user_id }, addedMemberId => {
            this.setState({ isAdded: true, addedMemberId });
        });
    };

    deleteUser = member_id => {
        this.props.onDelete(member_id, () => {
            this.setState({ isAdded: false });
        });
    };

    render() {
        const {
            id,
            smallImage,
            isMember,
            fullName,
            isAdding,
            addingMemberId,
            isRemoving,
            removingMemberId,
        } = this.props;
        // const { small_url } = image.data;
        const { isAdded, addedMemberId } = this.state;
        const disableAddButton = isAdding && addingMemberId === id;
        const disableRemoveButton = isRemoving && (removingMemberId === isMember || removingMemberId === addedMemberId);

        return (
            <UserRowContainer>
                {smallImage ? (
                    <ProfileAvatar size={'medium'} src={`${config.baseUrl}/${smallImage}`} />
                ) : (
                    <Icon.SearchUserDefaultImage />
                )}

                <UserName>
                    <Text>{fullName}</Text>
                </UserName>
                {isMember || isAdded ? (
                    <AddedButton onClick={() => this.deleteUser(addedMemberId || id)} disabled={disableRemoveButton}>
                        {disableRemoveButton ? <Spinner /> : 'ADDED'}
                    </AddedButton>
                ) : (
                    <AddButton disabled={disableAddButton} onClick={() => this.addUser(id)}>
                        {disableAddButton ? <Spinner /> : 'ADD MEMBER'}
                    </AddButton>
                )}
            </UserRowContainer>
        );
    }
}

const mapStateToProps = ({
    members: {
        statuses: {
            isMemberAdding: { isAdding, addingId },
            isMemberRemoving: { isRemoving, removingId },
        },
    },
}) => ({
    isAdding,
    addingMemberId: addingId,
    isRemoving,
    removingMemberId: removingId,
});

export default compose(connect(mapStateToProps))(AddMemberRow);



// WEBPACK FOOTER //
// ./src/UI/Components/Rows/AddMemberRow/index.js